// import React, { useState, memo } from 'react';
// import Select from 'react-select';

// // export default function SelectOption(props) {
// const SelectOption = memo(function SelectOption(props) {

// 	const [isClearable, setIsClearable] = useState(props.isClearable);
// 	const [isSearchable, setIsSearchable] = useState(true);
// 	const [isDisabled, setIsDisabled] = useState(props?.isDisabled?true:false);
// 	const [isLoading, setIsLoading] = useState(false);
// 	const [isRtl, setIsRtl] = useState(false);

// 	const { selected, data, placeholder, disabled } = props;

// 	const onChange = (data) => {
// 		const value = data === null ? "0" : data.value;
// 		props.changeEvent(value);
// 	};

// 	return (
// 		<>
// 			<Select
// 				className="basic-single"
// 				classNamePrefix="select"
// 				defaultValue={selected}
// 				isDisabled={isDisabled}
// 				isLoading={isLoading}
// 				isClearable={isClearable}
// 				isRtl={isRtl}
// 				isSearchable={isSearchable}
// 				name="color"
// 				options={data}
// 				onChange={onChange}
// 				placeholder={placeholder !== undefined ? placeholder : "Select"}
// 				styles={{
// 					control: (provided) => ({
// 						...provided,
// 						backgroundColor: isDisabled ? 'lightgrey' : 'white', // Apply grey only if disabled
// 						color: isDisabled ? 'lightgrey' : 'black'
// 					})
// 				}}
// 			/>
// 		</>
// 	);
// });
// export default SelectOption;

import React, { useState, memo } from "react";
import { Dropdown } from "react-bootstrap";

const SelectOption = memo(function SelectOption(props) {
	// const [isClearable, setIsClearable] = useState(props.isClearable);
	// const [isSearchable, setIsSearchable] = useState(true);
	// const [isLoading, setIsLoading] = useState(false);
	// const [isRtl, setIsRtl] = useState(false);
	const [isDisabled, setIsDisabled] = useState(props?.isDisabled ? true : false);

	const { selected, data, placeholder, disabled } = props;

	const selectedValue =
		typeof selected === "object" && selected !== null
		? selected.value
		: selected;

	const selectedLabel =
		typeof selected === "object" && selected !== null
		? selected.label
		: selected;

	const onChange = (item) => {
		const value = item === null ? "0" : item.value;
		props.changeEvent(value);
	};

	return (
		<Dropdown className="px-0">
			<Dropdown.Toggle
				id="select-option-toggle"
				disabled={isDisabled}
				className="voice-dropdown-toggle d-flex justify-content-between align-items-center outline-btn text-center btn btn-primary"
				style={{
					backgroundColor: isDisabled ? "lightgrey" : "white",
					color: isDisabled ? "grey" : "black",
					border: "1px solid #ced4da",
					width :"97%",
					padding: "12px 10px"
				}}
			
			>
				<span>
					{selectedLabel || (placeholder !== undefined ? placeholder : "Select")}
				</span>
			</Dropdown.Toggle>

			<Dropdown.Menu className="voice-dropdown-menu">
				{data &&
					data.map((item, index) => (
						<Dropdown.Item
							key={index}
							active={item.value === selectedValue}
							onClick={() => onChange(item)}
						>
							{item.label}
						</Dropdown.Item>
					))}
			</Dropdown.Menu>
		</Dropdown>
	);
});

export default SelectOption;
